import type {HTMLAttributes} from 'react'

import styles from './base-settings-page.module.css'

export function BaseSettingsPage({children, ...props}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div {...props} className={styles.BaseSettingsPage}>
      {children}
    </div>
  )
}

try{ BaseSettingsPage.displayName ||= 'BaseSettingsPage' } catch {}